/* global SmartPhoneNumber, MyForm, MyWindow, Loc */

window.MassMailingPrefs = {
	
	initPrefs : function(){

        var $form               = $('#prefsContent').find('.prefForm');
        var formID              = $form.attr('id');
		var $mobileTpl			= $('#mobileInput-tpl');
		var defaultCountryCode	= SmartPhoneNumber.getDefaultCountryCode($('#' + formID));
		var preferredCountries	= SmartPhoneNumber.getPreferredCountries(defaultCountryCode);
        
		var options  = {
            data        : { action: $form.data('action') },
			dataType	: 'json',
			success		: function(data){
				var formIsOk = MyForm.processJson(data, formID);
				
				if(formIsOk) {
					MyWindow.alert(Loc.g("Vos préférences ont bien été mises à jour"), {type: "confirm"});
				} else {
					MyWindow.alert(Loc.g("Certaines informations sont manquantes, vérifiez vos préférences"), {type: "error"});
				}
			}
		};
		
		$(window).on('focus', 'ul#emailsBAT input:last', function(){
   
			var $input = $(this);
			var $clone = $input.closest('li').clone();
			
			if($input.closest('ul').find('li:not(div.form-group li)').length < 5){
				
				$clone.find('input').val('');
				$clone.appendTo($input.closest('ul'));
				
			}
			
		});
        
        $('#addMobilesBAT').on('click', function(){

            if($('li:not(div.form-group li)', 'ul#mobilesBAT').length < 5){

                var $input = $('input.e164Number', $('ul#mobilesBAT div.form-input:last'));

                var $clone			= $($mobileTpl.html());
				var $inputCloned	= $clone.find('input.pref_mobilesBAT').addClass('e164Number');

                var position = parseInt($input.data('position')) + 1;

                $inputCloned.data('position', position);
				$inputCloned.attr('id', 'testMobile_' + position);

				SmartPhoneNumber.prepareOneField($inputCloned, preferredCountries, defaultCountryCode);
				$clone.appendTo($input.closest('ul'));

                if ($('li:not(div.form-group li)', 'ul#mobilesBAT').length === 5) $('#addMobilesBAT').remove()
            }
        });
		
		$(window).on('blur', 'ul#mobilesBAT div.form-input:eq(-2)', function(event){
			
			if(!$(event.srcElement).hasClass('selected-flag')){
				
				var $input = $('input.e164Number', $(this));

				if($input.val() == '' && $('ul#mobilesBAT input.e164Number:last').val() == ''){
					$('ul#mobilesBAT li:not(div.form-group li):last').remove();
				}
				
			}
			
		});

		$(window).on('blur','ul#emailsBAT input:eq(-2)', function(){
			if($(this).val() == '' && $('ul#emailsBAT input:last').val() == ''){
				$('ul#emailsBAT li:last').remove();
			}
		});
		
        MyTabs.initHorizontal(formID);
		
		MassMailingPrefs.checkedMassmailingOption(new Array("All", "Email", "SMS", "Phone", "Mail", "Custom"));
		
		MyForm.prepare(formID, 'massmailing_prefs', options);
		
	},
	
	checkedMassmailingOption : function(id) {

		if(id instanceof Array){
			id.forEach(function(element) {
				if($('#prefs_publicLinkOption' + element).is(':checked')){
					$('#container_massmailing_' + element).show();
				} else {
					$('#container_massmailing_' + element).hide();
				}
			});
		}else {
			if($('#prefs_publicLinkOption' + id).is(':checked')){
				$('#container_massmailing_' + id).show();
			} else {
				$('#container_massmailing_' + id).hide();
			}

			if ((id == 'All') && $('#prefs_publicLinkOptionAll').is(':checked')) {
				// Check all : uncheck others
				$('input[name^=prefs_publicLinkOption]').not('#prefs_publicLinkOptionAll').prop('checked', false);
				$('div[id^=container_massmailing_]').not('#container_massmailing_All').hide();
			}
			if ((id != 'All') && $('#prefs_publicLinkOption' + id).is(':checked')) {
				// check one other : uncheck the "all" checkbox
				$('#prefs_publicLinkOptionAll').prop('checked', false);
				$('#container_massmailing_All').hide();
			}
		}

	}
	
};